import { render, staticRenderFns } from "./Demand.vue?vue&type=template&id=b25bd7dc"
import script from "./Demand.vue?vue&type=script&lang=js"
export * from "./Demand.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\BuildAgent\\work\\136\\s\\Yahome.RecruitSystem.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b25bd7dc')) {
      api.createRecord('b25bd7dc', component.options)
    } else {
      api.reload('b25bd7dc', component.options)
    }
    module.hot.accept("./Demand.vue?vue&type=template&id=b25bd7dc", function () {
      api.rerender('b25bd7dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/back/Card/Demand.vue"
export default component.exports